import DataTable from '@sophocles/components/DataTable2/DataTable2';

export default DataTable;
